/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Scope_Once_Only_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo never picks up an event like this on its own." |
*
* @param {Meeting_Scope_Once_Only_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_scope_once_only_body = /** @type {((inputs?: Meeting_Scope_Once_Only_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Scope_Once_Only_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo pikt zo'n afspraak nooit vanzelf op.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo n'ajoute jamais ce genre d'événement de lui-même.")
	return /** @type {LocalizedString} */ ("Wundo never picks up an event like this on its own.")
});